import Vue from 'vue';
import Router from 'vue-router';

/* 首页 */
const home = r => require.ensure([], () => r(require('page/home.vue')));
/* 首页（直播活动 + 直播专栏） */
const homePage = r => require.ensure([], () => r(require('page/homePage/homePage.vue')));
/* 直播活动首页 */
const homeLive = r => require.ensure([], () => r(require('page/homePage/homeLive/liveView.main.vue')));
/* 直播专栏首页 */
const homeLiveColumn = r => require.ensure([], () => r(require('page/homePage/homeColumn/homeLiveColumn.vue')));
/* 专栏详情页 */
const liveColumn = r => require.ensure([], () => r(require('page/homePage/homeColumn/liveColumn.vue')));
/* 搜索页面 */
const search = r => require.ensure([], () => r(require('page/homePage/searchPage/searchPage.vue')));
/* 登录页面 */
const login = r => require.ensure([], () => r(require('page/login/main.login.vue')));
/* 管理员页面 */
const liveManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.main.vue')));
/* 管理员--正在直播 */
const livingManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.liveing.vue')));
/* 管理员--直播计划 */
const livePlanManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.livePlan.vue')));
/* 管理员--直播专栏 */
const liveColumnManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.liveColumn.vue')));
/* 管理员--历史直播 */
const liveHistoryManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.liveHistory.vue')));
/* 管理员 -- 直播审核 */
const liveCheckManage = r => require.ensure([], () => r(require('page/manageHome/liveManage.liveCheck.vue')));
/* 管理员 -- 平台设置 */
const platformInfo = r => require.ensure([], () => r(require('page/manageHome/platformInfo/platformInfo.vue')));
/* 管理员 -- 邮箱绑定页面 */
const emailManage = r => require.ensure([], () => r(require('page/manageHome/emailPage.vue')));
/* 管理员 -- 修改密码页面 */
const changePassword = r => require.ensure([], () => r(require('page/manageHome/changePassword.vue')));
/* 直播详情页 */
const liveShow = r => require.ensure([], () => r(require('page/livePlayer/liveshow.main.vue')));
/* 直播简介，直播扫码入口 */
const liveShowDetails = r => require.ensure([], () => r(require('page/livePlayer/liveshow.brief.vue')));
/* 移动端直播审核页面 */
const liveAudit = r => require.ensure([], () => r(require('page/manageHome/liveAudit/liveAudit.vue')));
/* 用户协议页面 */
const agreement = r => require.ensure([], () => r(require('page/agreement/agreement.vue')));
/* 并发数过大时中转页面 */
const loadingPage = r => require.ensure([], () => r(require('page/loadingPage/loadingPage.vue')));
/* 超过直播在线人数限制的中转页面 */
const limitPage = r => require.ensure([], () => r(require('page/loadingPage/limitPage.vue')));

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      redirect: '/homePage',
      children: [
        {
          path: 'homePage',
          name: 'homePage',
          component: homePage
        },
        {
          path: 'homeLive',
          name: 'homeLive',
          component: homeLive
        },
        {
          path: 'homeLiveColumn',
          name: 'homeLiveColumn',
          component: homeLiveColumn
        },
        {
          path: 'liveColumn',
          name: 'liveColumn',
          component: liveColumn
        },
        {
          path: '/liveShow',
          name: 'liveShow',
          component: liveShow
        },
        {
          path: '/liveShowDetails',
          name: 'liveShowDetails',
          component: liveShowDetails
        }
      ]
    },
    {
      path: '/loadingPage',
      name: 'loadingPage',
      component: loadingPage
    },
    {
      path: '/limitPage',
      name: 'limitPage',
      component: limitPage
    },
    {
      path: '/liveManage',
      name: 'liveManage',
      component: liveManage,
      meta: {
        login_require: true
      },
      redirect: '/liveManage/livingManage', // 默认显示正在直播页面
      children: [
        {
          path: 'platformInfo',
          name: 'platformInfo',
          component: platformInfo
        },
        {
          path: 'livingManage',
          name: 'livingManage',
          meta: {login_require: true},
          component: livingManage
        },
        {
          path: 'livePlanManage',
          name: 'livePlanManage',
          meta: {login_require: true},
          component: livePlanManage
        },
        {
          path: 'liveColumnManage',
          name: 'liveColumnManage',
          meta: {login_require: true},
          component: liveColumnManage
        },
        {
          path: 'liveHistoryManage',
          name: 'liveHistoryManage',
          meta: {login_require: true},
          component: liveHistoryManage
        },
        {
          path: 'liveCheckManage',
          name: 'liveCheckManage',
          meta: {login_require: true},
          component: liveCheckManage
        },
        {
          path: 'emailManage',
          name: 'liveEmailManage',
          meta: {login_require: true},
          component: emailManage
        },
        {
          path: 'changePassword',
          name: 'changePassword',
          meta: {login_require: true},
          component: changePassword
        }
      ]
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // {
    //   path: '/liveShowDetails',
    //   name: 'liveShowDetails',
    //   component: liveShowDetails
    // },
    {
      path: '/liveAudit',
      name: 'liveAudit',
      component: liveAudit
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0};
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js